import { render, staticRenderFns, recyclableRender, components } from "./z-paging-load-more.vue?vue&type=template&id=ef0d5cb6&scoped=true&"
var renderjs
import script from "./z-paging-load-more.vue?vue&type=script&lang=js&"
export * from "./z-paging-load-more.vue?vue&type=script&lang=js&"
import style0 from "./z-paging-load-more.vue?vue&type=style&index=0&id=ef0d5cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0d5cb6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/z-paging/components/z-paging/components/z-paging-load-more.vue"
export default component.exports